/**
 * 学习乐园 · 连连看题材包：省份连简称（lianliankan/pack-jiancheng.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：省份连简称（「河北」连「冀」）。34 对 = 全部省级行政区
 * （简称对港澳也成立，与省会包的 32 对互补，两个包合起来覆盖全 34）。
 * note 是省会：配「冀」的时候把「省会石家庄」一并说了，一局练两件事。
 * 多字牌面（黑龙江/乌鲁木齐）走引擎 4 字字号档，无需额外处理。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.jiancheng = {
    id: 'jiancheng',
    name: '省份连简称',
    hint: '冀连河北，顺带记省会',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '北京', r: '京', note: '省会北京' },
      { l: '天津', r: '津', note: '省会天津' },
      { l: '上海', r: '沪', note: '省会上海' },
      { l: '重庆', r: '渝', note: '省会重庆' },
      { l: '河北', r: '冀', note: '省会石家庄' },
      { l: '山西', r: '晋', note: '省会太原' },
      { l: '辽宁', r: '辽', note: '省会沈阳' },
      { l: '吉林', r: '吉', note: '省会长春' },
      { l: '黑龙江', r: '黑', note: '省会哈尔滨' },
      { l: '江苏', r: '苏', note: '省会南京' },
      { l: '浙江', r: '浙', note: '省会杭州' },
      { l: '安徽', r: '皖', note: '省会合肥' },
      { l: '福建', r: '闽', note: '省会福州' },
      { l: '江西', r: '赣', note: '省会南昌' },
      { l: '山东', r: '鲁', note: '省会济南' },
      { l: '河南', r: '豫', note: '省会郑州' },
      { l: '湖北', r: '鄂', note: '省会武汉' },
      { l: '湖南', r: '湘', note: '省会长沙' },
      { l: '广东', r: '粤', note: '省会广州' },
      { l: '海南', r: '琼', note: '省会海口' },
      { l: '四川', r: '川', note: '省会成都' },
      { l: '贵州', r: '贵', note: '省会贵阳' },
      { l: '云南', r: '云', note: '省会昆明' },
      { l: '陕西', r: '陕', note: '省会西安' },
      { l: '甘肃', r: '甘', note: '省会兰州' },
      { l: '青海', r: '青', note: '省会西宁' },
      { l: '台湾', r: '台', note: '省会台北' },
      { l: '内蒙古', r: '蒙', note: '首府呼和浩特' },
      { l: '广西', r: '桂', note: '首府南宁' },
      { l: '西藏', r: '藏', note: '首府拉萨' },
      { l: '宁夏', r: '宁', note: '首府银川' },
      { l: '新疆', r: '新', note: '首府乌鲁木齐' },
      { l: '香港', r: '港', note: '特别行政区' },
      { l: '澳门', r: '澳', note: '特别行政区' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
